import { render, staticRenderFns } from "./NewCardProject.vue?vue&type=template&id=849d2538&scoped=true"
import script from "./NewCardProject.vue?vue&type=script&lang=js"
export * from "./NewCardProject.vue?vue&type=script&lang=js"
import style0 from "./NewCardProject.vue?vue&type=style&index=0&id=849d2538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849d2538",
  null
  
)

export default component.exports